import React, { useEffect, useState } from "react";
import DropdownList from "react-widgets/DropdownList";
import axiosInstance from "Api";
import { ErrorMessage } from "formik";
import InputWrapper from "Pages/Profile/InputWrapper";

import {
    Col,
    FormGroup,
    Label,
    Row,
    Button,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Form, Formik } from "formik";
import { ReactComponent as PdfIcon } from "../../../assets/utils/images/svgs/PDF.svg";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";
import { useDocTypes, useSaveDocument, useSaveUserDocument } from "Api/Common/CommonComponents";


const HerinneringForm = ({ type, saveDocTypeValue, docTypeName, doc, toggle, updateData, filterCommunity, currentUser, registerWithoutDocument }) => {

    const [formDataState, setFormDataState] = useState({
        docType: '',
        herinneringDatum: '',
        file: '',
        registerWithoutDocument: ''

    });

    const { trigger: saveDocument } = useSaveDocument();
    const { trigger: saveUserDocument } = useSaveUserDocument();


    const validationSchema = Yup.object().shape({
        docType: Yup.string().required("Veld mag niet leeg zijn"),

        file: Yup.mixed().test(
            "file-required",
            "Veld mag niet leeg zijn",
            function (value) {
                if (registerWithoutDocument) return true;
                return !!value;
            }
        ),
    });

    const handleSubmit = (values, setSubmitting) => {
        setTimeout(() => {
            let formData = new FormData();
            formData.append(
                "saveWithoutDocument",
                registerWithoutDocument ? 1 : 0
            );

            if (!registerWithoutDocument && values.file) {
                formData.append("file", values.file);
            }

            formData.append("docType", values.docType);

            if (type !== "Gebruikers") {
                formData.append("herinneringDatum", values.herinneringDatum);
            } else {
                formData.append("iAdminId", currentUser.data.clooserId);
                formData.append("iCommunityId", filterCommunity[0].iCommunityId);
            }

            const requestFn =
                type === "Gebruikers" ? saveUserDocument : saveDocument;

            requestFn({
                method: "post",
                data: formData,
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
                .then((response) => {
                    
                        if (response.status == true) {
                            toast["success"]("Instellingen zijn bijgewerkt");
                            setFormDataState({
                                docType: "",
                                herinneringDatum: "",
                                file: "",
                                registerWithoutDocument: "",
                            });
                            toggle();
                            updateData();
                        }
                   
                })
                .catch((error) => console.log("catch error:", error))
                .finally(() => setSubmitting(false));
        }, 400);
    };

    const { data: docTypesResponse } = useDocTypes();

    const docTypeList =
        docTypesResponse?.status === true
            ? docTypesResponse.data
            : [];

    useEffect(() => {
        setFormDataState(prev => ({
            ...prev,
            docType: docTypeName,
            file: doc
        }));
    }, [docTypeName, doc]);

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={formDataState}
                validationSchema={validationSchema}
                onSubmit={

                    (values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>

                        <div>
                            <Row>
                                <Col md="12" sm="12" lg="12">

                                    {!registerWithoutDocument && (
                                        <FormGroup row>
                                            <Label className="setting-lebel-style text-start">
                                                Geselecteerd bestand
                                            </Label>

                                            <Col sm={12} className="setting-lebel-style text-start">
                                                <PdfIcon /> {doc !== '' && doc?.name ? doc.name : ''}
                                            </Col>

                                            <ErrorMessage
                                                name="file"
                                                component="small"
                                                className="block mt-2 invalid-feedback"
                                            />
                                        </FormGroup>
                                    )}

                                    <div className="custom-styling  mb-3">

                                        <InputWrapper label="Document type *" labelCol={3} className={'setting-lebel-style text-start'}>
                                            <DropdownList dataKey='vName' textField='vLabel'
                                                placeholder="Selecteer"
                                                className={"border rounded text-start"}
                                                onChange={(nextValue) => {
                                                    saveDocTypeValue(nextValue.iDocTypeId, nextValue.vName)
                                                    setFormDataState({ ...formDataState, docType: nextValue.vName })
                                                }}
                                                defaultValue={docTypeName}
                                                name="docType"
                                                data={docTypeList}
                                                required="true"
                                            />
                                        </InputWrapper>
                                        <ErrorMessage name="docType" component="small"
                                            className="block mt-2 invalid-feedback" />
                                    </div>

                                    {
                                        type !== "Gebruikers" &&
                                        <FormGroup row >
                                            <Label className={"setting-lebel-style text-start"}>
                                                Datum herinnering
                                            </Label>

                                            <Col sm={12} >
                                                <div className="input-group-text input-border-styling  d-flex justify-content-between">
                                                    <DatePicker
                                                        locale="nl"
                                                        name="herinneringDatum"
                                                        dateFormat="dd-MM-yyyy"
                                                        className="me-2 border-0 bg-transparent float-start w-100"
                                                        selected={(values.herinneringDatum !== '' && values.herinneringDatum !== undefined) ? new Date(values.herinneringDatum) : ''}
                                                        placeholderText={'dd-mm-yyyy'}
                                                        onChange={(val) => {
                                                            setFormDataState({ ...formDataState, herinneringDatum: moment(val).format('yyyy-MM-DD') })
                                                        }}
                                                    />
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <ErrorMessage name="herinneringDatum" component="small"
                                                    className="block mt-2 invalid-feedback" />
                                            </Col>
                                        </FormGroup>
                                    }

                                </Col>
                            </Row>
                            <Button className=" align-items-center btn-color-style mb-2 me-2 " size="sm" outline color="primary" type="submit" disabled={isSubmitting}  >
                                Opslaan
                            </Button>
                        </div>
                    </Form>

                )}
            </Formik>

        </>
    )
}

export default HerinneringForm;
